/**
 * Mod-K (1.I-2 deliverable 16), pure. Mod-Shift-K is capture (1.N-1) and Alt is another chord;
 * a press the editor already used (`core.mark.link` over a text selection) is left alone.
 */
export interface PaletteKeyEvent {
  readonly key: string;
  readonly metaKey: boolean;
  readonly ctrlKey: boolean;
  readonly altKey: boolean;
  readonly shiftKey: boolean;
  readonly isComposing?: boolean | undefined;
  readonly defaultPrevented?: boolean | undefined;
  preventDefault(): void;
}

/** Decides from `apple`, never from the machine it runs on. */
export function isPaletteKey(event: PaletteKeyEvent, apple: boolean): boolean {
  if (event.isComposing) return false;
  if (event.key.toLowerCase() !== 'k') return false;
  const mod = apple ? event.metaKey : event.ctrlKey;
  const other = apple ? event.ctrlKey : event.metaKey;
  return mod && !other && !event.altKey && !event.shiftKey;
}

/** The window listener's body: toggles the palette for Mod-K and keeps the browser's own Mod-K away. */
export function onPaletteKey(event: PaletteKeyEvent, apple: boolean, toggle: () => void): void {
  if (event.defaultPrevented) return;
  if (!isPaletteKey(event, apple)) return;
  event.preventDefault();
  toggle();
}
